import React, { useEffect, useMemo, useState } from "react";
import { Box, Divider } from "@mui/material";
import PreChartingHeader from "components/scribe/preCharting/header";
import WorkflowStepper from "components/scribe/preCharting/workflowStepper";
import PreChartingTabs from "components/scribe/preCharting/tabs";
import PreChartTab from "components/scribe/preCharting/preChartTab";
import CareGapsUI from "components/scribe/preCharting/careGapUI";
import DocumentsUI from "components/scribe/preCharting/documentsUI";
import MedicationsUI from "components/scribe/preCharting/medicationsUI";
import ClinicalNotesUI from "components/scribe/preCharting/clinicalNotesUI";
import AiMedCodes from "components/scribe/aiMedCodes";
import { useLocation, useNavigate } from "react-router-dom";

const tabs = [
  { key: "prechart", label: "Pre-Chart" },
  { key: "caregaps", label: "Care Gaps" },
  { key: "documents", label: "Documents" },
  { key: "medications", label: "Current Medications" },
  { key: "clinical", label: "Clinical Notes" },
  { key: "coding", label: "Coding" },
];

const PreCharting = () => {
  const [activeStep, setActiveStep] = useState("prechart");
  const [activeTab, setActiveTab] = useState("prechart");

  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.data;

  const isPreChartingDone =
    rowData?.precharting_id !== null && rowData?.precharting_id !== undefined;

  const workflowStages = useMemo(() => {
    return [
      {
        key: "appointment",
        title: "Appointment Setup",
        status: "Done",
        tab: "prechart",
        subtitle: "Visit scheduled",
      },
      {
        key: "prechart",
        title: "AI Pre-Chart",
        status: isPreChartingDone ? "Done" : "Active",
        tab: "prechart",
      },
      {
        key: "review",
        title: "Doctor Review",
        status: isPreChartingDone ? "Active" : "Not Done",
        tab: "caregaps",
      },
      {
        key: "recording",
        title: "Visit Recording",
        status: "Not Done",
        tab: "clinical",
      },
      {
        key: "coding_ai",
        title: "AI Coding",
        status: "Not Done",
        tab: "coding",
      },
      {
        key: "coder_review",
        title: "Human Coder Review",
        status: "Not Done",
        tab: "coding",
      },
      {
        key: "claim",
        title: "Claim Submission",
        status: "Not Done",
        tab: "coding",
      },
    ];
  }, [isPreChartingDone]);

  useEffect(() => {
    if (isPreChartingDone) {
      setActiveStep("review");
      setActiveTab("caregaps");
    } else {
      setActiveStep("prechart");
      setActiveTab("prechart");
    }
  }, [isPreChartingDone]);

  return (
    <Box
      sx={{
        height: "98vh",
        backgroundColor: "#fff",
      }}
    >
      <PreChartingHeader patient={rowData} onBack={() => navigate(-1)} />
      <Divider />

      <WorkflowStepper
        stages={workflowStages}
        activeStep={activeStep}
        onStepClick={(stage) => {
          setActiveTab(stage.tab);
          setActiveStep(stage.key);
        }}
      />

      <PreChartingTabs tabs={tabs} value={activeTab} setValue={setActiveTab} />
      <Divider />

      <Box sx={{ p: 2 }}>
        {activeTab === "prechart" && <PreChartTab />}
        {activeTab === "caregaps" && <CareGapsUI />}
        {activeTab === "documents" && <DocumentsUI />}
        {activeTab === "medications" && <MedicationsUI />}
        {activeTab === "clinical" && <ClinicalNotesUI />}
        {activeTab === "coding" && <AiMedCodes details={{}} readOnly={true} />}
      </Box>
    </Box>
  );
};

export default PreCharting;
